export const normalizeNavigatePath = (path = '') => {
    if (/^\//.test(path)) {
        return path
    } else {
        return `/${path}`
    }
}